module.exports = __webpack_public_path__ + "static/media/comment_author.05be83f5.svg";